import type { ChainType, SupWeb3Asset } from "@/types";
import React from "react";

import UiChipVaultTooltip from "@/components/Ui/Chip/Vault/AssetsTooltip";
import { SupAssetPair, SupCoinAlt } from "@repo/core-ui";
import UiTooltip from "@/components/Ui/Tooltip";

import Image from "next/image";
import { twMerge } from "tailwind-merge";

interface ChipVaultAssetsProps {
  assets: SupWeb3Asset[];
  vaultId: string;
  chain?: ChainType;
  showChain?: boolean;
  showTooltip?: boolean;
  useSmall?: boolean;
  className?: string;
}
export default function ChipVaultAssets({ assets, vaultId, chain, showChain, showTooltip = false, useSmall, className }: ChipVaultAssetsProps) {
  const initialAssets = assets.slice();
  const lastAsset = showChain ? initialAssets.splice(-1).shift() : undefined;

  return (
    <UiTooltip color="default" enable={showTooltip} arrowPlacement="bottom" content={<UiChipVaultTooltip assets={assets} vaultId={vaultId} />}>
      <div className={twMerge("flex items-center -space-x-3", showTooltip && "cursor-help", className)}>
        {initialAssets.map((asset, index) => (
          <Image
            key={`${vaultId}-${asset.symbol}-${index}`}
            className={twMerge(useSmall ? "h-6 w-6" : "h-8 w-8", "overflow-hidden rounded-full bg-neutral-950 object-cover object-center")}
            height={useSmall ? 24 : 32}
            alt={asset.name}
            width={useSmall ? 24 : 32}
            src={asset.image ?? "/assets/img/placeholder/token.svg"}
          />
        ))}
        {lastAsset && (
          <SupAssetPair
            small={useSmall}
            logo={lastAsset.image || <SupCoinAlt className={twMerge(useSmall ? "h-6 w-6" : "h-8 w-8", "rounded-full")} />}
            pairLogo={chain?.logo_url}
          />
        )}
      </div>
    </UiTooltip>
  );
}
